<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
/* global echarts */
// require('echarts/theme/macarons') // echarts theme
// import resize from './mixins/resize'

export default {
  // mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    location: {
      type: String,
      default: ''
    },
    chartTitle: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '1.8229rem'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Array,
      required: true
    },
    mode: {
      type: String,
      default: 'cubicInOut'
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions (expectedData) {
      var series = []
      if (this.mode === 'quadraticOut') {
        series.push(
          {
            name: this.chartTitle,
            smooth: true,
            type: 'line',
            itemStyle: {
              normal: {
                color: '#3888fa',
                lineStyle: {
                  color: '#3888fa',
                  width: 2
                },
                areaStyle: {
                  color: 'rgba(64,158,255,0.3)'
                }
              }
            },
            data: expectedData,
            animationDuration: 2800,
            animationEasing: 'quadraticOut'
          }
        )
      } else {
        series.push(
          {
            name: this.chartTitle,
            itemStyle: {
              normal: {
                color: '#FF005A',
                lineStyle: {
                  color: '#FF005A',
                  width: 2
                }
              }
            },
            smooth: true,
            type: 'line',
            data: expectedData,
            animationDuration: 2800,
            animationEasing: 'cubicInOut'
          }
        )
      }
      this.chart.setOption({
        title: {
          text: this.location + ' 近7天' + this.chartTitle,
          left: 'center',
          top: 5,
          textStyle: {
            color: '#ccc'
          }
        },
        xAxis: {
          data: ['1', '2', '3', '4', '5', '6', '7'],
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#aaa',
              type: 'dotted'
            }
          }

        },
        grid: {
          left: 10,
          right: 10,
          bottom: 20,
          top: 50,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        yAxis: {
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#aaa',
              type: 'dotted'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#aaa',
              type: 'dotted'
            }
          }
        },
        series: series
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index/LineChart.vue